/**
 * External dependencies
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import './styles.scss';

class Sidebar extends Component {
	static propTypes = {
		className: PropTypes.string,
	};

	render() {
		return (
			<ul className={classNames('sidebar', this.props.className)} data-tip-target='sidebar'>
				{this.props.children}
			</ul>
		);
	}
}
export default Sidebar;
